export default "__VITE_ASSET__BzEtTZGm__"